module.exports = __webpack_public_path__ + "img/img96.549c03a3.svg";